import React, { useState } from 'react'
import { ThemeProvider } from '@mui/material'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'
import { themeCreator } from './base'
import { StylesProvider } from '@mui/styles'

interface ThemeContextValue {
  setThemeName: (themeName: string) => void
  themeName: string
  toggleTheme: () => void
}

export const ThemeContext = React.createContext<ThemeContextValue>({
  setThemeName: () => {},
  themeName: 'PureLightTheme',
  toggleTheme: () => {},
})

const ThemeProviderWrapper: React.FC = (props) => {
  const curThemeName = localStorage.getItem('appTheme') || 'PureLightTheme'
  const [themeName, _setThemeName] = useState(curThemeName)
  const theme = themeCreator(themeName)

  const setThemeName = (themeName: string): void => {
    localStorage.setItem('appTheme', themeName)
    _setThemeName(themeName)
  }

  const toggleTheme = (): void => {
    const newTheme = themeName === 'PureLightTheme' ? 'PureDarkTheme' : 'PureLightTheme'
    setThemeName(newTheme)
  }

  return (
    <StylesProvider injectFirst>
      <ThemeContext.Provider value={{ setThemeName, themeName, toggleTheme }}>
        <ThemeProvider theme={theme}>
          <StyledThemeProvider theme={theme}>{props.children}</StyledThemeProvider>
        </ThemeProvider>
      </ThemeContext.Provider>
    </StylesProvider>
  )
}

export default ThemeProviderWrapper
